import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/app/(public)/[sport]/teams/[team]/[year]/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/primitives/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/team/roster-table.tsx");
